import { render, staticRenderFns } from "./StudioFinder.vue?vue&type=template&id=4a539793&scoped=true&"
import script from "./StudioFinder.vue?vue&type=script&lang=js&"
export * from "./StudioFinder.vue?vue&type=script&lang=js&"
import style0 from "./StudioFinder.vue?vue&type=style&index=0&id=4a539793&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a539793",
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Resize from 'vuetify/lib/directives/resize'
installDirectives(component, {Resize})
